import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';
import { articleImages } from '@/mocks/articleImages';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  const imageUrl = articleImages[article.imageSeq] || articleImages['article-emo-01'];

  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${article.slug}`} className="block">
        <div className="relative h-48 overflow-hidden">
          <img
            src={imageUrl}
            alt={article.title}
            title={`${article.title} - AI风月`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute top-3 left-3">
            <span className="px-3 py-1 text-xs rounded-full bg-primary-500/90 text-background-50 whitespace-nowrap">
              {article.categoryName}
            </span>
          </div>
        </div>
        <div className="p-5">
          <h3 className="text-lg font-semibold font-heading text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 mb-2">
            {article.title}
          </h3>
          <p className="text-sm text-foreground-600 line-clamp-2 mb-4 leading-relaxed">
            {article.excerpt}
          </p>
          <div className="flex items-center justify-between text-xs text-foreground-500">
            <div className="flex items-center gap-3">
              <span className="flex items-center gap-1 whitespace-nowrap">
                <i className="ri-calendar-line"></i>
                {article.date}
              </span>
              <span className="flex items-center gap-1 whitespace-nowrap">
                <i className="ri-time-line"></i>
                {article.readTime}
              </span>
            </div>
            <span className="flex items-center gap-1 text-primary-500 group-hover:translate-x-1 transition-transform duration-200 whitespace-nowrap">
              阅读更多
              <i className="ri-arrow-right-line"></i>
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}